import { render } from "./TestResultGuideForLemonProduct.vue?vue&type=template&id=b66b2220&scoped=true"
import script from "./TestResultGuideForLemonProduct.vue?vue&type=script&lang=js"
export * from "./TestResultGuideForLemonProduct.vue?vue&type=script&lang=js"

import "./TestResultGuideForLemonProduct.vue?vue&type=style&index=0&id=b66b2220&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66b2220"]])

export default __exports__